// removed by extract-text-webpack-plugin
module.exports = {"Archived":"Archived__Archived__3tmST"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Archived/Archived.css
// module id = 395
// module chunks = 0